import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { RoutingService } from '@spartacus/core';
import { CurrentItemService } from '@spartacus/organization/administration/components';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { UigBranchesState } from '../store/uig-branches.reducer';
import { selectUigBranchDetails } from '../store/uig-branches.selectors';
import { BranchForm } from '../uig-branches/uig-branches.models';

@Injectable({
  providedIn: 'root',
})
export class UigCurrentBranchService extends CurrentItemService<BranchForm> {
  constructor(
    protected routingService: RoutingService,
    protected store: Store<UigBranchesState>
  ) {
    super(routingService);
  }

  protected getParamKey() {
    return "name";
  }

  protected getItem(name: string): Observable<BranchForm> {
    return this.store.select(selectUigBranchDetails).pipe(
      filter((data) => data != null)
    );
  }

  getError(code: string): Observable<boolean> {
    //not used, had to implement it
    return null;
  }
}